import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import Header from "./Components/Header";
import Body from "./Components/Body";
import {createBrowserRouter, Outlet, RouterProvider} from "react-router-dom";
import About from "./Components/About";
import Error from "./Components/Error";
import Contact from "./Components/Contact";
import RestaurentMenu from "./Components/RestaurentMenu";
import { lazy } from "react";

const Grocery = lazy(() => import('./Components/Grocery'));
/* Components in our Application */
// Header
//     - Logo
//     - Tabs or Nav Items like (home, about, cart)
// Body
//     - Search Bar
//     - Restaurent Container
//          - Restaurent Cards
// Footer
//     - Copyright or Disclaimer
//     - Links


const AppLayout = () => (
    <div className="app">
        <Header/>
        <Outlet/>
    </div>
);

const appRouter = createBrowserRouter([
    {
        path: "/",
        element: <AppLayout/>,
        errorElement: <Error/>,
        children: [
            {
                path: "/",
                element: <Body/>
            },
            {
                path: "/about",
                element: <About/>
            },
            {
                path: "/contact",
                element: <Contact/>
            },
            {
                path: "/restaurent/:resId",
                element: <RestaurentMenu/>
            },
            {
                path: "/grocery",
                element: <Suspense fallback={<div>Loading</div>}><Grocery/></Suspense>
            }
        ]
    } 
])


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={appRouter}/>);